// опционально: тип
export interface TeamMemberCard {
  name: string;
  role?: string;
  projects?: string;
  cannotLiveWithout: string;
  favoriteSong: string;
  songAuthor?: string;
  dreamTrip: string;
  image: string;
  hoverImage: string;
  linkedin?: string;
  mirrorImage?: boolean;
  splitRole?: boolean;
}

// 1. Базовый набор карточек без повторов
const baseTeam: TeamMemberCard[] = [
  {
    name: "Artem K.",
    role: "CEO",
    projects: "All",
    cannotLiveWithout: "Travel",
    favoriteSong: "Lost Frequencies",
    dreamTrip: "Round the world trip",
    image: "/v2/team/Artem-K.png",
    hoverImage: "/v2/team/Artem-K-hover.png",
    linkedin: "https://www.linkedin.com/in/artem-kushneryk/",
  },

  {
    name: "Maxim M.",
    role: "Project Manager",
    projects: "Tokenizer.Estate",
    cannotLiveWithout: "Evolving & helping",
    favoriteSong: "The Kids Aren't Alright",
    songAuthor: "The Offspring",
    dreamTrip: "Sailing cruise to Antarctica",
    image: "/v2/team/Maxim-M.png",
    hoverImage: "/v2/team/Maxim-M-hover.png",
    linkedin: "https://www.linkedin.com/in/maxim-mamizerov/",
  },
  {
    name: "Leonhard S.",
    role: "Chief technology officer",
    projects: "RWA Estate, RWA Market",
    cannotLiveWithout: "Family",
    favoriteSong: "Singing in My Dream",
    songAuthor: "okameP",
    dreamTrip: "Japan",
    image: "/v2/team/Leonhard-S.png",
    hoverImage: "/v2/team/Leonhard-S-hover.png",
    linkedin: "",
  },

  {
    name: "Vasilii S.",
    role: "Team Lead Frontend",
    projects: "All",
    cannotLiveWithout: "Travel",
    favoriteSong: "Daft Punk",
    dreamTrip: "Son Doong Cave, Vietnam",
    image: "/v2/team/Vasilii-S.png",
    hoverImage: "/v2/team/Vasilii-S-hover.png",
    linkedin: "https://www.linkedin.com/in/mr-pinacolada/",
  },
  {
    name: "Sergey S.",
    role: "QA Engineer",
    projects: "Tokenizer",
    cannotLiveWithout: "Travel",
    favoriteSong: "Iron Man",
    songAuthor: "Black Sabbath",
    dreamTrip: "New Zealand, Peru, Mexico",
    image: "/v2/team/Sergey-S.png",
    hoverImage: "/v2/team/Sergey-S-hover.png",
    linkedin: "https://www.linkedin.com/in/shirkosergey/",
  },
  {
    name: "Lena L.",
    role: "Product Designer",
    projects: "RWA Market, Tokenizer",
    cannotLiveWithout: "Protein bar",
    favoriteSong: "Alice",
    songAuthor: "Bassvictim",
    dreamTrip: "North Korea",
    image: "/v2/team/Lena-L.png",
    hoverImage: "/v2/team/Lena-L-hover.png",
    linkedin: "https://www.linkedin.com/in/lena-lazich-0ba962235/",
  },
  {
    name: "Veranika S.",
    role: "Product & Comms Designer",
    projects: "Tokenizer.Estate, RETC, RWA Estate",
    cannotLiveWithout: "Adventure, flavor, friendship, discovery",
    favoriteSong: "Carmen",
    songAuthor: "Stromae",
    dreamTrip: "2-week Iceland trip by car",
    image: "/v2/team/Veranika-S.png",
    hoverImage: "/v2/team/Veranika-S-hover.png",
    linkedin: "https://www.linkedin.com/in/veranika-sasnouskaya/",
  },
  {
    name: "Vlad Z.",
    role: "Frontend developer",
    projects: "RWA Market",
    cannotLiveWithout: "Music",
    favoriteSong: "Sleepwalking",
    songAuthor: "Bring Me The Horizon",
    dreamTrip: "Everest",
    image: "/v2/team/Vlad-Z.png",
    hoverImage: "/v2/team/Vlad-Z-hover.png",
    linkedin: "https://www.linkedin.com/in/vlad-zale-4b35462a5/",
  },
  {
    name: "Georgy R.",
    role: "Frontend developer",
    projects: "RWA Estate, Tokenizer, RETC",
    cannotLiveWithout: "Meat",
    favoriteSong: "Sultans of Swing",
    songAuthor: "Dire Straits",
    dreamTrip: "Australia",
    image: "/v2/team/Georgy-R.png",
    hoverImage: "/v2/team/Georgy-R-hover.png",
    linkedin: "https://www.linkedin.com/in/georgyrevazashvili/",
  },

  {
    name: "Nikita K.",
    role: "Sales Manager",
    projects: "Tokenizer",
    cannotLiveWithout: "Travel",
    favoriteSong: "Nocturne in C Sharp Minor (No. 20)",
    songAuthor: "Chopin",
    dreamTrip: "Rio de Janeiro, Brazil",
    image: "/v2/team/Nikita-K.png",
    hoverImage: "/v2/team/Nikita-K-hover.png",
    linkedin: "https://www.linkedin.com/in/nikita-kotelnikov-75310a355/",
  },

  {
    name: "Mariia G.",
    role: "Analyst",
    projects: "All",
    cannotLiveWithout: "Gummies and crafting",
    favoriteSong: "Overcompensate",
    songAuthor: "Twenty One Pilots",
    dreamTrip: "Diving on the Great Barrier Reef",
    image: "/v2/team/Mariia-G.jpg",
    hoverImage: "/v2/team/Mariia-G-hover.png",
    linkedin: "https://www.linkedin.com/in/mariyaglushkova/",
  },
  {
    name: "Radik O.",
    role: "Backend Developer",
    projects: "Tokenizer",
    cannotLiveWithout: "Turning complex business logic into elegant code",
    favoriteSong: "California Love",
    songAuthor: "2Pac ft. Dr. Dre",
    dreamTrip: "Tech architecture tour: Japan's tech hubs + Silicon Valley",
    image: "/v2/team/Radik-O.png",
    hoverImage: "/v2/team/Radik-O-hover.png",
    linkedin: "https://www.linkedin.com/in/radion-osipyan-98003a359/",
  },
  {
    name: "Danil R.",
    role: "Frontend <br/> Developer",
    projects: "Tokenizer",
    cannotLiveWithout: "Interesting tasks",
    favoriteSong: "Boulevard of Broken Dreams",
    songAuthor: "Green Day",
    dreamTrip: "Niagara Falls",
    image: "/v2/team/Danil-R.jpg",
    hoverImage: "/v2/team/Danil-R-hover.png",
    linkedin: "",
    splitRole: true,
  },
  {
    name: "Kirill G.",
    role: "Backend <br/> Developer",
    projects: "Tokenizer",
    cannotLiveWithout: "My wife and my cat",
    favoriteSong: "Heroes",
    songAuthor: "David Bowie",
    dreamTrip: "Kamchatka",
    image: "/v2/team/Kirill-G.jpg",
    hoverImage: "/v2/team/Kirill-G-hover.png",
    linkedin: "https://www.linkedin.com/in/kirill-gordievich/",
    mirrorImage: true,
    splitRole: true,
  },
  {
    name: "Nikita E.",
    role: "Frontend Developer",
    projects: "Tokenizer",
    cannotLiveWithout: "Evolution and self-development",
    favoriteSong: "Mama's Boy",
    songAuthor: "Dominic Fike",
    dreamTrip: "Eurotour in a sports car",
    image: "/v2/team/Nikita-E.jpg",
    hoverImage: "/v2/team/Nikita-E-hover.png",
    linkedin: "https://www.linkedin.com/in/nikita-egorov-299a67284/",
  },
  {
    name: "Evgenii G.",
    cannotLiveWithout: "family, football, video games",
    role: "QA Engineer",
    projects: "Tokenizer",
    favoriteSong: "Living Colour",
    songAuthor: "Cult of Personality",
    dreamTrip: "Real Madrid match at Santiago Bernabeu Stadium",
    image: "/v2/team/Evgenii-G.jpg",
    hoverImage: "/v2/team/Evgenii-G-hover.png",
    linkedin: "https://www.linkedin.com/in/evgenii-goryukov-03ab3437b/",
  },
];

// если у тебя есть ещё блок «новых» людей — можно вынести во второй массив

// 2. Хелпер для повторения массивов
const repeatArray = <T>(items: T[], times: number): T[] =>
  Array.from({ length: times }, () => items).flat();

// 3. Итоговый cardData: сколько раз нужно — задаёшь числами
export const cardData: TeamMemberCard[] = [
  ...repeatArray(baseTeam, 6), // базовый блок повторяется 4 раза
];
